import { Component, OnInit } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';

@Component({
  selector: 'app-videolist',
  templateUrl: './videolist.component.html',
  styleUrls: ['./videolist.component.scss'],
})
export class VideolistComponent implements OnInit {

  headerTitle: any;
  VideoList: any = [];
  width: any=0;
  videoDisplay = [];
  langcontext: any;
  trustedVideoUrl: SafeResourceUrl;
  array_of_objects: any;


  constructor(public platform: Platform, public navctrl: NavController,public api: RestapiService, public domSanitizer: DomSanitizer, public cmndecl: CommonDeclarationService, public cmndef: CommonDefinitionService) { 
    platform.ready().then(() => {
      this.width = platform.width()- 50;
      console.log('Width: ' + platform.width());
      console.log('Height: ' + platform.height());
    });
  }

  ionViewWillEnter(): void {
    console.log("hello");
    this.array_of_objects = this.cmndecl.youtubelist;
    for(let i of this.array_of_objects){
      i.trustedVideoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(i.videourl);
    }
    
  }

  PlayingVideo(idx){
    window.open(idx.videourl, "_system");
    console.log(idx);
  }

  ngOnInit() {
    if (this.cmndecl.LanguageJson) {
      this.langcontext = this.cmndecl.LanguageJson.pages[0]['youtubeVideo'];
      this.headerTitle = this.langcontext.hdr;
    }
    else {
      this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndecl.LanguageJson['pages'][0].youtubeVideo;
      this.headerTitle = this.langcontext.hdr;
    }
  }

}
